import { CheckEmployee, getCurrentCheckCompanyId } from "winslow-core";
import { Alert, AlertDescription } from "../../../ds2/components/Alert";
import { Button } from "../../../ds2/components";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";

type AppCheckEmployeeStatusProps = {
    checkEmployee: CheckEmployee | undefined | null;
    allowCreate: boolean;
    hasBasics: boolean; // true if ssn_last_four is provided
    handleCreateEmployee: () => void;
    onViewOnboarding?: () => void;

    // handleLaunchCheckOnboarding: () => void;
    // handleLaunchCheckImplementation: () => void;
}

export const AppCheckEmployeeStatus = ({ 
    checkEmployee,
    allowCreate,
    hasBasics,
    handleCreateEmployee,
    onViewOnboarding,
    // handleLaunchCheckOnboarding,
    // handleLaunchCheckImplementation
}: AppCheckEmployeeStatusProps) => {

    const storeUser = useSelector(selectUser);
    const checkCompanyId = getCurrentCheckCompanyId(storeUser);

    return (
        <>
            {/* basics not done yet */}
            {checkEmployee && !hasBasics &&
                <Alert variant="destructive" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Please supply the required information to enroll in payroll.
                    </AlertDescription>
                </Alert>
            }

            {/* Onboarding not completed */}
            {checkEmployee && checkEmployee.onboard?.status !== "completed" && hasBasics && 
                <Alert variant="destructive" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Employee onboarding is not completed. Current status: <strong>{checkEmployee.onboard?.status || "unknown"}</strong>. 
                        You cannot save changes until onboarding is completed.
                    </AlertDescription>
                    <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                        {onViewOnboarding && (
                            <Button
                                label="View"
                                variant="secondary"
                                onClick={onViewOnboarding}
                            />
                        )}
                        <Button
                            label="Resolve"
                            variant="secondary"
                            // onClick={handleLaunchCheckOnboarding}
                        />
                    </div>
                </Alert>
            }
            {!checkEmployee && allowCreate && checkCompanyId &&
                <Alert variant="warning" className="app-pay-configuration-alert">
                    <AlertDescription>
                        Create payroll employee record.
                        <Button
                            label="Create"
                            variant="secondary"
                            onClick={handleCreateEmployee}
                        />
                    </AlertDescription>
                </Alert>
            }
            {!checkEmployee && allowCreate && !checkCompanyId &&
                <Alert variant="warning" className="app-pay-configuration-alert">
                    <AlertDescription>
                        To enroll employees in payroll, please enroll your company first.
                    </AlertDescription>
                </Alert>
            }
        </>
    )
}

